import axios from "axios";

export const BASE_URL = process.env.REACT_APP_SERVER_API_URL;
export const cookie = (key) =>
  (new RegExp((key || "=") + "=(.*?); ", "gm").exec(document.cookie + "; ") || [
    "",
    null,
  ])[1];

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "X-CSRFToken": cookie("csrftoken"),
    "Content-Type": "application/json",
  },
});

export const fetch = async (
  url,
  options = { cache: true, thirdParty: false, headers: {} }
) => {
  const cacheKey = `cache_${url}`;

  if (options.cache && !options.thirdParty) {
    // Attempt to get the cached response
    const cachedResponse = sessionStorage.getItem(cacheKey);
    if (cachedResponse) {
      return JSON.parse(cachedResponse);
    }
  }

  try {
    let response;
    if (options.thirdParty) {
      // Create a new Axios instance for third-party requests
      const thirdPartyApi = axios.create({
        headers: options.headers,
      });
      response = await thirdPartyApi.get(url);
    } else {
      if ((options.headers?.method || "").toLowerCase() === "delete") {
        response = await api.delete(url);
      } else {
        response = await api.get(url);
      }
    }

    // Cache the response if caching is enabled and not a third-party request
    if (options.cache && !options.thirdParty) {
      sessionStorage.setItem(cacheKey, JSON.stringify(response.data));
    }

    return response.data;
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
    throw error;
  }
};

export const post = async (
  url,
  data,
  options = { cache: false, thirdParty: false, headers: {} }
) => {
  try {
    let response;
    if (options.thirdParty) {
      // Create a new Axios instance for third-party requests
      const thirdPartyApi = axios.create({
        headers: options.headers,
      });

      response = await thirdPartyApi.post(url, data);
    } else {
      // Use the existing Axios instance for standard requests
      response = await api.post(url, data);
    }

    return response.data;
  } catch (error) {
    console.error(`Error posting data to ${url}:`, error);
    throw error;
  }
};

export const put = async (url, data) => {
  try {
    const response = await api.put(url, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating data to ${url}:`, error);
    throw error;
  }
};
